import { render } from "./slider.vue?vue&type=template&id=c147d9d4"
import script from "./slider.vue?vue&type=script&lang=js"
export * from "./slider.vue?vue&type=script&lang=js"

import "./slider.vue?vue&type=style&index=0&id=c147d9d4&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__